import styled from "styled-components";

const ModalBase = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  padding: "45px 16px 24px 24px",
  position: "absolute",
  width: "393px",
  height: "145px",
  background: "#FFFFFF",
  boxShadow:
    "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2)",
  borderRadius: "8px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

const ModalMessage = styled.div`
  width: 368px;

  & span{
    color: #000000;
    fontWeight: bold;
  }
`;

export {ModalBase, ModalMessage };
